import create from "./create"
import read from "./read"
import update from "./update"
import remove from "./remove"
import release from "./release"

const INITIAL_ENTITY_STATE = {
  data: null,
  involved: 0,
  error: null,
}

export default function entityReducer(state = INITIAL_ENTITY_STATE, action) {
  let nextState = state
  nextState = create(nextState, action)
  nextState = read(nextState, action)
  nextState = update(nextState, action)
  nextState = remove(nextState, action)
  return release(nextState, action)
}
